import axios from 'axios'
import { useAuthStore } from '@/stores/authStore'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api'
export const BASE_URL = API_URL.endsWith('/api') ? API_URL.slice(0, -4) : API_URL

const api = axios.create({
  baseURL: API_URL,
})

// Request interceptor: Attach token to headers
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().auth.accessToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor: Handle errors (401 Unauthorized)
api.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      const refreshToken = useAuthStore.getState().auth.refreshToken
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_URL}/auth/refresh`, { refreshToken })
          const { token } = response.data

          useAuthStore.getState().auth.setAccessToken(token)
          originalRequest.headers.Authorization = `Bearer ${token}`

          return api(originalRequest)
        } catch (refreshError) {
          useAuthStore.getState().auth.reset()
          return Promise.reject(refreshError)
        }
      } else {
        useAuthStore.getState().auth.reset()
      }
    }

    return Promise.reject(error)
  }
)

export default api
